import React from 'react';
import { useTheme } from '@websky/core/src/theme';
import { useTranslation } from 'react-i18next';
const FlightCardAirline = ({ flightNumber, airline }) => {
    const { t } = useTranslation('FlightCard');
    const { FlightCard: css } = useTheme('FlightCard');
    return (React.createElement("div", { className: css.airline },
        React.createElement("span", { className: css.airline__name },
            t('Flight operated by'),
            " ",
            airline),
        ",\u00A0",
        React.createElement("span", { className: css.airline__number }, flightNumber)));
};
export default FlightCardAirline;
